import { makeAutoObservable } from 'mobx';
import SecureFile from 'main/stores/secure_upload/SecureFile';
import _ from 'lodash';

class SecureUploadState {
  store;
  secureFile;
  submitted = false;
  errors = {};
  isUploading = false;

  constructor(store) {
    makeAutoObservable(this, {
      store: false
    });

    this.store = store;
    this.secureFile = new SecureFile();
  }

  onUploadStarted() {
    this.isUploading = true;
  }

  onUploadFinished() {
    this.isUploading = false;
  }

  validate() {
    this.errors = {};
    if (_.isEmpty(this.secureFile.awsFiles)) {
      this.errors.awsFiles = 'Choose a file to upload';
    }
    return _.isEmpty(this.errors);
  }

  async sendToCollage() {
    if (!this.validate()) return null;

    const {model, errors} = await this.store.postSecureFile(this.secureFile);
    this.errors = errors;
    if (model) {
      this.submitted = true;
    }
  }
}

export default SecureUploadState;
